import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastService, AuthService } from '../../public-api';
import { Router } from '@angular/router';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);
  const authService = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        toastService.addError({ detail: 'Unauthorized' });
        authService.removeUserData();

        const currentUrl = router.url;
        queueMicrotask(() => {
          router.navigate(['/auth/login'], {
            queryParams: { returnUrl: currentUrl },
          });
        });
      }

      return throwError(() => error);
    }),
  );
};
